import { Location } from "@angular/common";

import { currentLang, getWindowRef, SearchLocationData } from "@hiptraveler/common";

interface LocationObject {
  country: string;
  formattedAddr: string;
  id: string;
  location: string;
};

export function toLocationObject(location?: SearchLocationData): LocationObject {
  return {
    id: location?.locId || '',
    location: location?.name || '',
    country: location?.country || '',
    formattedAddr: location?.location || ''
  };
}

export function syncPageTitle(location: Location, pageTitle?: string): void {

  let newPageUrl = '';

  if (getWindowRef()?.location?.pathname?.includes('itinerary') && pageTitle) {
    newPageUrl = `/${currentLang()}/compose/itinerary/${pageTitle}`;
  }

  if (getWindowRef()?.location?.pathname?.includes('travel-story') && pageTitle) {
    newPageUrl = `/${currentLang()}/compose/travel-story/${pageTitle}`;
  }

  newPageUrl && setTimeout(() => {
    location.replaceState(newPageUrl);
  }, 500);
}

/**
 * Extracts every <img> src URL from an HTML string.
 * @param html - raw HTML that may contain <img … src="…">
 * @returns an array of src URLs in the order they appear
 */
export function getImageSrcs(html: string = ''): string[] {
  const srcs: string[] = [];
  const re = /<img[^>]+src=["']([^"']+)["']/g; // capture the src value

  let match: RegExpExecArray | null;
  while ((match = re.exec(html))) {
    srcs.push(match[1]);
  }
  return srcs;
}
